import { TFunction } from "i18next";
import validator from "validator";
import { z } from "zod";

export const getEntityFormSchema = (t: TFunction) => {
  return z.object({
    acronym: z
      .string()
      .min(1, { message: t("entities.errors.acronym-required") })
      .max(5, { message: t("entities.errors.acronym-max-length") }),
    name: z.string().min(1, { message: t("entities.errors.name-required")}),
    fiscalNumber: z
      .string()
      .min(1, { message: t("entities.errors.fiscal-number-required") })
      .refine(str => validator.isTaxID(str, "pt-PT"), {
        message: t("entities.errors.invalid-fiscal-number"),
      }),
    website: z
      .string()
      .transform(str => (str.trim() === "" ? null : str))
      .nullable()
      .refine(str => str === null || validator.isURL(str), {
        message: t("entities.errors.invalid-website"),
      }),
    notes: z.string().nullable().optional(),
  });
};

export type EntityForm = z.infer<ReturnType<typeof getEntityFormSchema>>;
